import * as Joi from 'joi';

import { validationErrorGeneralStringMessagesField } from '../../validation';

export const setAppVersionUnavailableSchema = Joi.object({
  reason: Joi.string().max(200).min(3).required().messages(validationErrorGeneralStringMessagesField),
});
